const Footer = () => (
  <div className='bg-surface text-primary-text font-roboto'>
    <div className='bg-s03dp w-full h-12 flex items-center justify-center text-sm'>
      © Mattox Coins &amp; Currency | World Bank Note Sales
    </div>
  </div>
);

export default Footer;
